// src/utils/roadmap.js
// 6x20 roadmap: 同类向下堆叠，满行则右移；超过 20 列则顶掉最旧列（shift left）

export function buildRoadmap(results, rows = 6, cols = 20, mapFn) {
    const grid = Array.from({ length: rows }, () => Array.from({ length: cols }, () => null));

    let col = 0;
    let row = 0;
    let lastKey = null;

    const shiftLeft = () => {
        for (let r = 0; r < rows; r++) {
            for (let c = 0; c < cols - 1; c++) {
                grid[r][c] = grid[r][c + 1];
            }
            grid[r][cols - 1] = null;
        }
        col = cols - 1;
    };

    const place = (r, c, cell) => {
        if (r < 0 || r >= rows) return;
        if (c < 0) return;
        if (c >= cols) {
            shiftLeft();
            c = col;
        }
        grid[r][c] = cell;
    };

    const firstEmptyRowInCol = (c) => {
        for (let r = 0; r < rows; r++) {
            if (!grid[r][c]) return r;
        }
        return rows - 1;
    };

    for (let i = 0; i < (results || []).length; i++) {
        const it = results[i];
        const cell = mapFn(it);
        const key = cell && cell.key != null ? String(cell.key) : String(it);

        if (lastKey == null) {
            place(row, col, cell);
            lastKey = key;
            continue;
        }

        if (key === lastKey) {
            // 同类：尽量往下
            if (row + 1 < rows && !grid[row + 1][col]) {
                row = row + 1;
            } else {
                // 该列满了：右移
                col = col + 1;
                if (col >= cols) shiftLeft();
                row = firstEmptyRowInCol(col);
            }
            place(row, col, cell);
        } else {
            // 不同类：新起一列，从顶开始
            col = col + 1;
            if (col >= cols) shiftLeft();
            row = 0;
            place(row, col, cell);
            lastKey = key;
        }
    }

    return grid;
}
